module.exports = __webpack_public_path__ + "img/screen-manual-2.420a3600.png";